import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TyresIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74C7.18 20.74 3.18 16.76 3.18 11.96ZM12 19.02C15.86 19.02 19.02 15.84 19.02 11.96C19.02 8.08 15.86 4.9 12 4.9C8.14 4.9 4.98 8.08 4.98 11.96C4.98 15.84 8.14 19.02 12 19.02ZM6.78 11.96C6.78 9.18 9.2 6.8 12 6.8C14.8 6.8 17.22 9.18 17.22 11.96C17.22 14.74 14.8 17.12 12 17.12C9.2 17.12 6.78 14.74 6.78 11.96ZM12 15.42C13.92 15.42 15.42 13.88 15.42 11.96C15.42 10.04 13.92 8.5 12 8.5C10.08 8.5 8.58 10.04 8.58 11.96C8.58 13.88 10.08 15.42 12 15.42ZM13.62 11.96C13.62 12.86 12.9 13.6 12 13.6C11.1 13.6 10.38 12.86 10.38 11.96C10.38 11.06 11.1 10.32 12 10.32C12.9 10.32 13.62 11.06 13.62 11.96Z" />
    </SvgIcon>
  );
});
